import { createContext, ReactChild } from 'react';

export interface CheckboxProps<T> {
  label: ReactChild;
  value: T;
  name?: string;
  /**
   * Should not be set manually by the caller,
   * this prop is passed down from {@link CheckboxGroup}
   */
  index?: number;
  /**
   * Should not be set manually by the caller,
   * this prop is passed down from {@link CheckboxGroup}
   */
  checked?: boolean;
  children?: React.ReactNode;
  intermediateState?: boolean;
  onChange?: () => void;
}

export const CHECKBOX_CONTEXT = createContext({
   
  toggle: null as (value: any, checkboxIndex: number) => void
});
